var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("w-input", {
                attrs: { label: "dossier naam", fancy: "" },
                model: {
                  value: _vm.value.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "name", $$v)
                  },
                  expression: "value.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("w-input", {
                attrs: { label: "BTW Nummer", fancy: "" },
                model: {
                  value: _vm.value.vatNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vatNumber", $$v)
                  },
                  expression: "value.vatNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "8", md: "6", lg: "6" } },
            [
              _c("w-input", {
                attrs: { label: "Straat naam", fancy: "" },
                model: {
                  value: _vm.value.streetName,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "streetName", $$v)
                  },
                  expression: "value.streetName",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "4", md: "4", lg: "2" } },
            [
              _c("w-input", {
                attrs: { label: "nr.", fancy: "" },
                model: {
                  value: _vm.value.streetNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "streetNumber", $$v)
                  },
                  expression: "value.streetNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "8", md: "6", lg: "6" } },
            [
              _c("w-input", {
                attrs: { label: "stad/gemeente", fancy: "" },
                model: {
                  value: _vm.value.cityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "cityName", $$v)
                  },
                  expression: "value.cityName",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "4", md: "4", lg: "2" } },
            [
              _c("w-input", {
                attrs: { label: "Postcode", fancy: "" },
                model: {
                  value: _vm.value.postalCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "postalCode", $$v)
                  },
                  expression: "value.postalCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("w-input", {
                attrs: { label: "Landcode", fancy: "" },
                model: {
                  value: _vm.value.countryCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "countryCode", $$v)
                  },
                  expression: "value.countryCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("w-input", {
                attrs: { label: "Tel", fancy: "" },
                model: {
                  value: _vm.value.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "phone", $$v)
                  },
                  expression: "value.phone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "10", lg: "8" } },
            [
              _c("w-input", {
                attrs: { label: "E-mail", fancy: "" },
                model: {
                  value: _vm.value.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "email", $$v)
                  },
                  expression: "value.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: {
                  label:
                    "'Bewerkt' gebeurtenissen niet tonen in verkoop historiek",
                },
                model: {
                  value: _vm.value.settings.HideSaleModifiedHistoryEvent,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.value.settings,
                      "HideSaleModifiedHistoryEvent",
                      $$v
                    )
                  },
                  expression: "value.settings.HideSaleModifiedHistoryEvent",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: { label: "Copyright verbergen op verkoopdocumenten" },
                model: {
                  value: _vm.value.settings.HideCopyrightOnSales,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.settings, "HideCopyrightOnSales", $$v)
                  },
                  expression: "value.settings.HideCopyrightOnSales",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: { label: "Verwijderde verkoopdocumenten uitschakelen" },
                model: {
                  value: _vm.value.settings.DeletedSalesDisabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.settings, "DeletedSalesDisabled", $$v)
                  },
                  expression: "value.settings.DeletedSalesDisabled",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }